import { render } from "./custom-js.vue?vue&type=template&id=ad1e14ea"
import script from "./custom-js.vue?vue&type=script&lang=js"
export * from "./custom-js.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__